import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

//Wiggle animation function
function wiggle(target) {
  let wiggleTL = gsap.timeline({
    repeat: 2,
    repeatDelay: 1
  });

  gsap.set(target, {
    transformOrigin:"50% 50%"
  })

  wiggleTL.from(target, {rotation: 6, duration: 0.01, ease: "sine.inOut"})
    .to(target, {rotation: -10, duration: 0.28, ease: "sine.inOut"})
    .to(target, {rotation: 18, duration: 0.30, ease: "sine.inOut"})
    .to(target, {rotation: -6, duration: 0.20, ease: "sine.inOut"})
    .to(target, {rotation: 6, duration: 0.11, ease: "sine.inOut"})
    .to(target, {rotation: 0, duration: 0.17, ease: "sine.inOut"})
}

//Teach and lead Section Animations
let teachTrigger = {
  trigger: "#teach-and-lead",
  start: "top bottom",
  scrub: true
}

gsap.set("#teach-and-lead .shape.variation-1", {
  transformOrigin:"50% 50%"
})
gsap.to("#teach-and-lead .shape.variation-1", {
  yPercent: 200,
  xPercent: -200,
  rotation: -25,
  ease: "none",
  scrollTrigger: teachTrigger
});

gsap.set("#teach-and-lead .shape.variation-2", {
  transformOrigin:"50% 50%"
})
gsap.to("#teach-and-lead .shape.variation-2", {
  yPercent: 200,
  rotation: 45,
  ease: "none",
  scrollTrigger: teachTrigger
});

gsap.set("#teach-and-lead .shape.variation-3", {
  transformOrigin:"50% 50%"
})
gsap.to("#teach-and-lead .shape.variation-3", {
  yPercent: 200,
  rotation: 180,
  ease: "none",
  scrollTrigger: teachTrigger
});


//Close Out Section Animations
let closeOutTrigger = {
  trigger: "#close-out",
  start: "top bottom",
  scrub: true
}

gsap.to("#close-out .shape.variation-1", {
  yPercent: 200,
  xPercent: 200,
  scale: 0.4,
  ease: "none",
  scrollTrigger: closeOutTrigger,
});

gsap.set("#close-out .shape.variation-2", {
  transformOrigin:"50% 50%"
})
gsap.to("#close-out .shape.variation-2", {
  yPercent: 200,
  rotation: 180,
  ease: "none",
  scrollTrigger: closeOutTrigger,
});

gsap.set("#close-out .shape.variation-3", {
  transformOrigin:"50% 50%"
})
gsap.to("#close-out .shape.variation-3", {
  yPercent: 250,
  rotation: 720,
  ease: "none",
  scrollTrigger: closeOutTrigger,
});

gsap.to("#close-out .shape.wiggle", {
  yPercent: 250,
  ease: "none",
  scrollTrigger: closeOutTrigger,
});


//Postcards Section Animations
let postcardsTrigger = {
  trigger: "#postcards",
  start: "top bottom",
  scrub: true
}

gsap.set("#postcards .shape.variation-1", {
  transformOrigin:"50% 50%"
})
gsap.to("#postcards .shape.variation-1", {
  yPercent: 150,
  rotation: 180,
  ease: "none",
  scrollTrigger: postcardsTrigger
});

gsap.set("#postcards .shape.variation-2", {
  transformOrigin:"50% 50%"
})
gsap.to("#postcards .shape.variation-2", {
  yPercent: 150,
  rotation: 180,
  ease: "none",
  scrollTrigger: postcardsTrigger
});

gsap.to("#postcards .shape.variation-3", {
  yPercent: 150,
  xPercent: 150,
  ease: "none",
  scrollTrigger: postcardsTrigger
});

//Act with heart Section Animations
let heartTrigger = {
  trigger: "#act-with-heart",
  start: "top bottom",
  scrub: true
}

gsap.to("#act-with-heart .shape.variation-1", {
  yPercent: 300,
  xPercent: 300,
  scale: 0.4,
  ease: "none",
  scrollTrigger: heartTrigger
});

gsap.set("#act-with-heart .shape.variation-2", {
  transformOrigin:"50% 50%"
})
gsap.to("#act-with-heart .shape.variation-2", {
  yPercent: 300,
  rotation: 360,
  ease: "none",
  scrollTrigger: heartTrigger
});

gsap.to("#act-with-heart .shape.wiggle", {
  yPercent: 300,
  ease: "none",
  scrollTrigger: heartTrigger
});

//Trigger for the wiggle
ScrollTrigger.create({
  trigger: "#act-with-heart",
  start:"top center",
  onEnter: function() { wiggle("#act-with-heart .wiggle") },
  once: true
});

ScrollTrigger.create({
  trigger: "#close-out",
  start:"top center",
  onEnter: function() { wiggle("#close-out .wiggle") },
  once: true
});
